import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import CloseButton from 'components/CloseButton';
import { getCategoryLogo } from '../../WStoreUtils';
import './WStoreConfirmation.css';

const PurchaseTradeConfirmationBody = props => (
  <>
    <CloseButton urlIcon onClick={props.onClose} />
    <div className="thank-you">THANK YOU!</div>
    <div className="message">{props.message}</div>
    <Link to="/rewards">
      <button
        type="button"
        className="view-wstore-confirmation-button"
        onClick={props.onClose}
      >
        VIEW REWARD
      </button>
    </Link>
  </>
);

PurchaseTradeConfirmationBody.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func
};

const QuestItemConfirmationBody = props => {
  const {
    selectedItem,
    purchaseResponseMsg,
    purchaseEmailMsg,
    closeConfirmationPage
  } = props;
  const questAwardData = selectedItem.prizeData.questAwardData;
  const prizes = questAwardData.quest.prizes.prizes;

  return (
    <div className="quest-confirmation-container">
      <CloseButton urlIcon onClick={props.onClose} />
      <div className="confirmation-image-container">
        <img
          className="confirmation-image"
          src={selectedItem.imageUrl || props.PurpleW}
          alt={selectedItem.name}
        />
        <ul className="circle-container-icons">
          {prizes.map((prize, index) => (
            <li key={index}>
              <img src={getCategoryLogo(prize.category)} alt={prize.category} />
            </li>
          ))}
        </ul>
      </div>
      <div className="quest-item-title">{selectedItem.name}</div>
      <div className="confirmation-info">
        <div className="quest-message">{purchaseResponseMsg}</div>
        <div className="email-message">{purchaseEmailMsg}</div>
      </div>
      <button
        type="button"
        className="view-wstore-quest-confirmation-button"
        onClick={closeConfirmationPage}
      >
        VIEW QUEST
      </button>
    </div>
  );
};

QuestItemConfirmationBody.propTypes = {
  selectedItem: PropTypes.shape({
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    prizeData: PropTypes.shape({
      questAwardData: PropTypes.shape({
        quest: PropTypes.shape({
          prizes: PropTypes.shape({
            prizes: PropTypes.arrayOf({
              category: PropTypes.string
            })
          })
        })
      })
    })
  }),
  message: PropTypes.string,
  onClose: PropTypes.func,
  closeConfirmationPage: PropTypes.func,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string
};

const PurchaseErrorBody = props => (
  <>
    <CloseButton urlIcon onClick={props.onClose} />
    <div className="thank-you">Oops!</div>
    <div className="message">{props.purchaseResponseMsg}</div>
    <div className="close-btn-container">
      <button
        type="button"
        className="view-wstore-confirmation-button"
        onClick={props.onClose}
      >
        Close
      </button>
    </div>
  </>
);

PurchaseErrorBody.propTypes = {
  purchaseResponseMsg: PropTypes.string,
  onClose: PropTypes.func
};

function WStoreConfirmation(props) {
  let BodyComponent;
  if (props.purchaseError) {
    BodyComponent = PurchaseErrorBody;
  } else if (props.isQuestItem) {
    BodyComponent = QuestItemConfirmationBody;
  } else {
    BodyComponent = PurchaseTradeConfirmationBody;
  }

  return (
    <Modal
      className="wstore-confirmation-modal"
      show={true}
      onHide={props.onClose}
    >
      <Modal.Body>
        <BodyComponent {...props} />
      </Modal.Body>
    </Modal>
  );
}

WStoreConfirmation.propTypes = {
  selectedItem: PropTypes.shape({
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    prizeData: PropTypes.shape({
      questAwardData: PropTypes.shape({
        quest: PropTypes.shape({
          prizes: PropTypes.shape({
            prizes: PropTypes.arrayOf(
              PropTypes.shape({
                category: PropTypes.string
              })
            )
          })
        })
      })
    })
  }),
  message: PropTypes.string,
  onClose: PropTypes.func,
  closeConfirmationPage: PropTypes.func,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  purchaseError: PropTypes.bool,
  isQuestItem: PropTypes.bool
};

export default WStoreConfirmation;
